/**
 * Coordinates the expandable search with the other header panels.
 */
(function (Drupal, once) {
  'use strict';

  Drupal.behaviors.headerSearch = {
    attach() {
      // BigPipe can deliver the toggle and controlled panel separately.
      document.querySelectorAll('.header-search__toggle').forEach((toggle) => {
        const header = toggle.closest('.site-header');
        const panel = document.getElementById(toggle.getAttribute('aria-controls'));
        if (!header || !panel) return;

        once('header-search', [toggle]).forEach(() => {
          const closeButton = panel.querySelector('.site-search-panel__close');
          const isOpen = () => toggle.getAttribute('aria-expanded') === 'true';
          const close = (returnFocus = false) => {
            header.classList.remove('site-header_search-open');
            toggle.setAttribute('aria-expanded', 'false');
            panel.inert = true;
            if (returnFocus) toggle.focus({ preventScroll: true });
          };
          // Preserve the server-rendered open state on the results page.
          if (!isOpen()) close();

          toggle.addEventListener('click', () => {
            if (isOpen()) {
              close();
              return;
            }
            header.dispatchEvent(new CustomEvent('adocs:header-panel-open', { detail: toggle }));
            panel.inert = false;
            header.classList.add('site-header_search-open');
            toggle.setAttribute('aria-expanded', 'true');
            panel.querySelector('input[name="search"]')?.focus({ preventScroll: true });
          });

          closeButton?.addEventListener('click', () => close(true));

          header.addEventListener('adocs:header-panel-open', (event) => {
            if (event.detail !== toggle) close();
          });
          document.addEventListener('click', (event) => {
            if (!header.contains(event.target) && !event.target.closest('.ui-autocomplete')) {
              close();
            }
          });
          document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && isOpen() && !event.defaultPrevented) {
              close(true);
            }
          });
        });
      });
    },
  };
})(Drupal, once);
